import { stringify } from 'qs';
import request from '@/services/request';
import { url } from '../service-utils';




/**
 * 最新文章
 * 页面：最新文章页
 * 前端：洪芳
 * 后端：陈陈
 * @params {Object} params: demo传参对象
 */
export async function getNewestNews(params) {
  return request(`${url.url}/v3/microsite/web/getNewestNews?${stringify(params)}`);
}


/**
 * 获取orgid
 * 页面：最新文章页
 * 前端：洪芳
 * 后端：陈陈
 * @params {Object} params: demo传参对象
 */
export async function getOrgid(params) {
  return request(`${url.url}/v3/cfg/getorgid?${stringify(params)}`);
}

/**
 * 标签列表
 * 页面：新建/编辑文章
 * 前端：洪芳
 * 后端： 陈陈
 * @params {Object} params: demo传参对象
 */
export async function getLabelList(params) {
  return request(`${url.url}/v3/label/list/byAddNews?${stringify(params)}`);
}
